import { CarbonUser } from "./carbonUser";

export interface ICreateMerchantApiData {
  contactName: string;
  country: string;
  currency: string;
  email: string;
  industryCode: string | null;
  makeEmailAdmin: boolean;
  merchantReferrerCode: string;
  name: string;
  platform: string;
  companySize: string;
  marketingOptIn: boolean;
}

export interface IAcceptMerchantInvitationApiData {
  email: string;
}

export const MerchantProgramType = {
  FLIGHT: 'FLIGHT',
  JOURNEY: 'JOURNEY',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export interface MerchantProgramme {
  type: keyof typeof MerchantProgramType;
  code: string;
  useAsDefault: boolean;
  createdAt: Date;
}

export interface IMerchant {
  category: any;
  code: string;
  country: string;
  currency: string;
  email: string;
  id: string;
  industryCode: string;
  name: string;
  platform: string;
  pledgeTaken: boolean;
  referrerMerchantCode: string;
  shortDescription: string;
  thumbnailUrl: string;
  url: string;
  preferredBasketCode: string;
  companySize: string;
  programmes: MerchantProgramme[] | [];
}

export type MerchantState = {
  merchant: IMerchant | null;
  merchantUsers: IMerchant[] | null;
  isMerchantLoading: boolean;
};

export type MerchantContextType = {
  merchant: IMerchant | null;
  merchantUsers: IMerchant[] | null;
  getMerchant: (user: CarbonUser | null, merchantId?: string) => void;
  getMerchantUsers: (merchantIds?: string[]) => any;
  getAdminRelationshipFromUser: (user: any, merchantId?: string) => {
    role: string;
    merchantId: string;
  } | null;
  isMerchantLoading: boolean;
};
